export const SEARCH_CATEGORIES = {
  CAREER_OPPORTUNITIES_INTERNSHIPS: 'INTERNSHIPS',
  CAREER_OPPORTUNITIES_JOBS: 'JOBS',
  CAREER_OPPORTUNITIES_CAREER_PATH: 'CAREER_PATH',
  CAREER_OPPORTUNITIES_EMPLOYERS: 'EMPLOYERS',

  SCHOLARSHIPS_SCHOLARSHIPS: 'SCHOLARSHIPS',

  SCHOLARSHIPS_FINANCIAL_AID_COMPETENCY: 'FINANCIAL_AID_COMPETENCY',

  // institutions - come back to this

  RESOURCES_NUGGET_VIDEO: 'NUGGET_VIDEO',
  RESOURCES_NUGGET_BOOK: 'NUGGET_BOOK',
  RESOURCES_NUGGET_ARTICLE: 'NUGGET_ARTICLE',
  RESOURCES_COMPETENCY: 'COMPETENCY',

  TOOLS: 'TOOLS',

  PEOPLE: 'PEOPLE',
  PEOPLE_INTERNAL: 'PEOPLE_INTERNAL',
  PEOPLE_EXTERNAL: 'PEOPLE_EXTERNAL',

  NUGGET_STORIES: 'NUGGET_STORIES',

  NUGGET_GROW_BY_DOING: 'NUGGET_GROW_BY_DOING',
} as const;

export const SEARCH_CATEGORIES_SCHOLARSHIPS = {
  TYPE_ALL: 'SCHOLARSHIP_TYPE_ALL',
  TYPE_SCHOLARSHIPS: 'SCHOLARSHIP_TYPE_SCHOLARSHIP',
  TYPE_FORGIVABLE_LOAN: 'SCHOLARSHIP_TYPE_FORGIVABLE_LOAN',
  TYPE_GRANT: 'SCHOLARSHIP_TYPE_GRANT',
  TYPE_CORPORATE: 'SCHOLARSHIP_TYPE_CORPORATE',
  TYPE_FELLOWSHIP: 'SCHOLARSHIP_TYPE_FELLOWSHIP',

  PRE_FILTERED: 'SCHOLARSHIP_AWARD_PRE_FILTERED',
} as const;

export const SEARCH_CATEGORIES_INTERNSHIPS = {
  MSA_ALL: 'INTERNSHIP_MSA_ALL',
  MSA_ATLANTA: 'INTERNSHIP_MSA_ATLANTA',
  MSA_AUSTIN: 'INTERNSHIP_MSA_AUSTIN',
  MSA_BALTIMORE: 'INTERNSHIP_MSA_BALTIMORE',
  MSA_BIRMINGHAM: 'INTERNSHIP_MSA_BIRMINGHAM',
  MSA_BOSTON: 'INTERNSHIP_MSA_BOSTON',
  MSA_BUFFALO: 'INTERNSHIP_MSA_BUFFALO',
  MSA_CHARLOTTE: 'INTERNSHIP_MSA_CHARLOTTE',
  MSA_CHICAGO: 'INTERNSHIP_MSA_CHICAGO',
  MSA_CINCINNATI: 'INTERNSHIP_MSA_CINCINNATI',
  MSA_CLEVELAND: 'INTERNSHIP_MSA_CLEVELAND',
  MSA_COLUMBUS: 'INTERNSHIP_MSA_COLUMBUS',
  MSA_DALLAS: 'INTERNSHIP_MSA_DALLAS',
  MSA_DENVER: 'INTERNSHIP_MSA_DENVER',
  MSA_DETROIT: 'INTERNSHIP_MSA_DETROIT',
  MSA_HARTFORD: 'INTERNSHIP_MSA_HARTFORD',
  MSA_HOUSTON: 'INTERNSHIP_MSA_HOUSTON',
  MSA_INDIANAPOLIS: 'INTERNSHIP_MSA_INDIANAPOLIS',
  MSA_JACKSONVILLE: 'INTERNSHIP_MSA_JACKSONVILLE',
  MSA_KANSAS_CITY: 'INTERNSHIP_MSA_KANSAS_CITY',
  MSA_LAS_VEGAS: 'INTERNSHIP_MSA_LAS_VEGAS',
  MSA_LOS_ANGELES: 'INTERNSHIP_MSA_LOS_ANGELES',
  MSA_LOUISVILLE: 'INTERNSHIP_MSA_LOUISVILLE',
  MSA_MEMPHIS: 'INTERNSHIP_MSA_MEMPHIS',
  MSA_MIAMI: 'INTERNSHIP_MSA_MIAMI',
  MSA_MILWAUKEE: 'INTERNSHIP_MSA_MILWAUKEE',
  MSA_MINNEAPOLIS: 'INTERNSHIP_MSA_MINNEAPOLIS',
  MSA_NASHVILLE: 'INTERNSHIP_MSA_NASHVILLE',
  MSA_NEW_ORLEANS: 'INTERNSHIP_MSA_NEW_ORLEANS',
  MSA_NEW_YORK: 'INTERNSHIP_MSA_NEW_YORK',
  MSA_OKLAHOMA_CITY: 'INTERNSHIP_MSA_OKLAHOMA_CITY',
  MSA_ORLANDO: 'INTERNSHIP_MSA_ORLANDO',
  MSA_PHILADELPHIA: 'INTERNSHIP_MSA_PHILADELPHIA',
  MSA_PHOENIX: 'INTERNSHIP_MSA_PHOENIX',
  MSA_PITTSBURGH: 'INTERNSHIP_MSA_PITTSBURGH',
  MSA_PORTLAND: 'INTERNSHIP_MSA_PORTLAND',
  MSA_PROVIDENCE: 'INTERNSHIP_MSA_PROVIDENCE',
  MSA_RALEIGH: 'INTERNSHIP_MSA_RALEIGH',
  MSA_RICHMOND: 'INTERNSHIP_MSA_RICHMOND',
  MSA_RIVERSIDE: 'INTERNSHIP_MSA_RIVERSIDE',
  MSA_SACRAMENTO: 'INTERNSHIP_MSA_SACRAMENTO',
  MSA_SALT_LAKE_CITY: 'INTERNSHIP_MSA_SALT_LAKE_CITY',
  MSA_SAN_ANTONIO: 'INTERNSHIP_MSA_SAN_ANTONIO',
  MSA_SAN_DIEGO: 'INTERNSHIP_MSA_SAN_DIEGO',
  MSA_SAN_FRANCISCO: 'INTERNSHIP_MSA_SAN_FRANCISCO',
  MSA_SAN_JOSE: 'INTERNSHIP_MSA_SAN_JOSE',
  MSA_SEATTLE: 'INTERNSHIP_MSA_SEATTLE',
  MSA_ST_LOUIS: 'INTERNSHIP_MSA_ST_LOUIS',
  MSA_TAMPA: 'INTERNSHIP_MSA_TAMPA',
  MSA_VIRGINIA_BEACH: 'INTERNSHIP_MSA_VIRGINIA_BEACH',
  MSA_WASHINGTON: 'INTERNSHIP_MSA_WASHINGTON',

  MSA_REMOTE: 'INTERNSHIP_MSA_REMOTE',

  CAREER_PATH_ALL: 'INTERNSHIP_CAREER_PATH_ALL',

  INDUSTRY_ALL: 'INTERNSHIP_INDUSTRY_ALL',

  JOB_TYPE_ALL: 'INTERNSHIP_JOB_TYPE_ALL',
  JOB_TYPE_FULL_TIME: 'INTERNSHIP_JOB_TYPE_FULL_TIME',
  JOB_TYPE_INTERNSHIP: 'INTERNSHIP_JOB_TYPE_INTERNSHIP',
} as const;

export const SEARCH_CATEGORIES_COLLEGES = {
  COLLEGE_ALL: 'COLLEGE_ALL',

  COLLEGE_TYPE_ALL: 'COLLEGE_TYPE_ALL',
  COLLEGE_TYPE_FOUR_YEAR: 'COLLEGE_TYPE_FOUR_YEAR',
  COLLEGE_TYPE_TWO_YEAR: 'COLLEGE_TYPE_TWO_YEAR',

  COLLEGE_SIZE_ALL: 'COLLEGE_SIZE_ALL',
  COLLEGE_SIZE_VERY_SMALL: 'COLLEGE_SIZE_VERY_SMALL',
  COLLEGE_SIZE_SMALL: 'COLLEGE_SIZE_SMALL',
  COLLEGE_SIZE_MEDIUM: 'COLLEGE_SIZE_MEDIUM',
  COLLEGE_SIZE_LARGE: 'COLLEGE_SIZE_LARGE',

  COLLEGE_REGION_ALL: 'COLLEGE_REGION_ALL',

  COLLEGE_STATE_ALL: 'COLLEGE_STATE_ALL',
  COLLEGE_STATE_ALABAMA: 'COLLEGE_STATE_ABBREVIATION_AL',
  COLLEGE_STATE_ALASKA: 'COLLEGE_STATE_ABBREVIATION_AK',
  COLLEGE_STATE_ARIZONA: 'COLLEGE_STATE_ABBREVIATION_AZ',
  COLLEGE_STATE_ARKANSAS: 'COLLEGE_STATE_ABBREVIATION_AR',
  COLLEGE_STATE_CALIFORNIA: 'COLLEGE_STATE_ABBREVIATION_CA',
  COLLEGE_STATE_COLORADO: 'COLLEGE_STATE_ABBREVIATION_CO',
  COLLEGE_STATE_CONNECTICUT: 'COLLEGE_STATE_ABBREVIATION_CT',
  COLLEGE_STATE_DELAWARE: 'COLLEGE_STATE_ABBREVIATION_DE',
  COLLEGE_STATE_FLORIDA: 'COLLEGE_STATE_ABBREVIATION_FL',
  COLLEGE_STATE_GEORGIA: 'COLLEGE_STATE_ABBREVIATION_GA',
  COLLEGE_STATE_HAWAII: 'COLLEGE_STATE_ABBREVIATION_HI',
  COLLEGE_STATE_IDAHO: 'COLLEGE_STATE_ABBREVIATION_ID',
  COLLEGE_STATE_ILLINOIS: 'COLLEGE_STATE_ABBREVIATION_IL',
  COLLEGE_STATE_INDIANA: 'COLLEGE_STATE_ABBREVIATION_IN',
  COLLEGE_STATE_IOWA: 'COLLEGE_STATE_ABBREVIATION_IA',
  COLLEGE_STATE_KANSAS: 'COLLEGE_STATE_ABBREVIATION_KS',
  COLLEGE_STATE_KENTUCKY: 'COLLEGE_STATE_ABBREVIATION_KY',
  COLLEGE_STATE_LOUISIANA: 'COLLEGE_STATE_ABBREVIATION_LA',
  COLLEGE_STATE_MAINE: 'COLLEGE_STATE_ABBREVIATION_ME',
  COLLEGE_STATE_MARYLAND: 'COLLEGE_STATE_ABBREVIATION_MD',
  COLLEGE_STATE_MASSACHUSETTS: 'COLLEGE_STATE_ABBREVIATION_MA',
  COLLEGE_STATE_MICHIGAN: 'COLLEGE_STATE_ABBREVIATION_MI',
  COLLEGE_STATE_MINNESOTA: 'COLLEGE_STATE_ABBREVIATION_MN',
  COLLEGE_STATE_MISSISSIPPI: 'COLLEGE_STATE_ABBREVIATION_MS',
  COLLEGE_STATE_MISSOURI: 'COLLEGE_STATE_ABBREVIATION_MO',
  COLLEGE_STATE_MONTANA: 'COLLEGE_STATE_ABBREVIATION_MT',
  COLLEGE_STATE_NEBRASKA: 'COLLEGE_STATE_ABBREVIATION_NE',
  COLLEGE_STATE_NEVADA: 'COLLEGE_STATE_ABBREVIATION_NV',
  COLLEGE_STATE_NEW_HAMPSHIRE: 'COLLEGE_STATE_ABBREVIATION_NH',
  COLLEGE_STATE_NEW_JERSEY: 'COLLEGE_STATE_ABBREVIATION_NJ',
  COLLEGE_STATE_NEW_MEXICO: 'COLLEGE_STATE_ABBREVIATION_NM',
  COLLEGE_STATE_NEW_YORK: 'COLLEGE_STATE_ABBREVIATION_NY',
  COLLEGE_STATE_NORTH_CAROLINA: 'COLLEGE_STATE_ABBREVIATION_NC',
  COLLEGE_STATE_NORTH_DAKOTA: 'COLLEGE_STATE_ABBREVIATION_ND',
  COLLEGE_STATE_OHIO: 'COLLEGE_STATE_ABBREVIATION_OH',
  COLLEGE_STATE_OKLAHOMA: 'COLLEGE_STATE_ABBREVIATION_OK',
  COLLEGE_STATE_OREGON: 'COLLEGE_STATE_ABBREVIATION_OR',
  COLLEGE_STATE_PENNSYLVANIA: 'COLLEGE_STATE_ABBREVIATION_PA',
  COLLEGE_STATE_RHODE_ISLAND: 'COLLEGE_STATE_ABBREVIATION_RI',
  COLLEGE_STATE_SOUTH_CAROLINA: 'COLLEGE_STATE_ABBREVIATION_SC',
  COLLEGE_STATE_SOUTH_DAKOTA: 'COLLEGE_STATE_ABBREVIATION_SD',
  COLLEGE_STATE_TENNESSEE: 'COLLEGE_STATE_ABBREVIATION_TN',
  COLLEGE_STATE_TEXAS: 'COLLEGE_STATE_ABBREVIATION_TX',
  COLLEGE_STATE_UTAH: 'COLLEGE_STATE_ABBREVIATION_UT',
  COLLEGE_STATE_VERMONT: 'COLLEGE_STATE_ABBREVIATION_VT',
  COLLEGE_STATE_VIRGINIA: 'COLLEGE_STATE_ABBREVIATION_VA',
  COLLEGE_STATE_WASHINGTON: 'COLLEGE_STATE_ABBREVIATION_WA',
  COLLEGE_STATE_WEST_VIRGINIA: 'COLLEGE_STATE_ABBREVIATION_WV',
  COLLEGE_STATE_WISCONSIN: 'COLLEGE_STATE_ABBREVIATION_WI',
  COLLEGE_STATE_WYOMING: 'COLLEGE_STATE_ABBREVIATION_WY',
} as const;

export const ALL_SEARCH_CATEGORIES = {
  ...SEARCH_CATEGORIES,
  ...SEARCH_CATEGORIES_SCHOLARSHIPS,
  ...SEARCH_CATEGORIES_INTERNSHIPS,
  ...SEARCH_CATEGORIES_COLLEGES,
};
